import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
export const useForgottenPasswordSchema = () => {
    const { t } = useTranslation();
    return Yup.object({
        email: Yup.string()
            .email(t('common.form.validation.email'))
            .required(t('common.form.validation.required'))
    });
};
